import { useLoadedDocument } from './useLoadedDocument';

/** The loaded content's tech domains, as used to scope bar raiser permissions. */
export interface ContentTechDomains {
  readonly mainTechDomain: string | undefined;
  readonly techDomains: readonly string[] | undefined;
}

/**
 * Reads the loaded content's tech domains out of its template metadata. Both
 * fields are undefined while no document is loaded or the template omits them.
 */
export function useContentTechDomains(): ContentTechDomains {
  const document = useLoadedDocument();

  // The content's tech domains live in its template metadata; read them the
  // same way ContentMetadataViewModel does.
  const metadata = (document?.content.templateMetadata ?? {}) as Record<string, unknown>;
  const mainTechDomain =
    typeof metadata.mainTechDomain === 'string' ? metadata.mainTechDomain : undefined;
  const techDomains = Array.isArray(metadata.techDomains)
    ? metadata.techDomains.filter((d): d is string => typeof d === 'string')
    : undefined;

  return { mainTechDomain, techDomains };
}
